// The reply pill's count. Stream cards hydrate only a few preview posts into
// `sorted_answers` (FeedCardProjection::MAX_PREVIEW_ANSWERS) while keeping the full
// ordered `sorted_answer_ids`, so counting objects alone undercounts the thread.
// Ids include archived posts; only hydrated posts can reveal that, so subtract those.
// Optimistic posts may exist as objects before their id lands — never report fewer
// than the hydrated unarchived posts.
export function questUnarchivedAnswerCount(quest: any): number {
    if (!quest) return 0
    const answers = Array.isArray(quest.sorted_answers) ? quest.sorted_answers : []
    const hydratedCount = answers.filter((answer: any) => answer && !answer.archive).length
    if (!Array.isArray(quest.sorted_answer_ids)) return hydratedCount

    const archivedIds = new Set(
        answers
            .filter((answer: any) => answer?.archive && answer.id != null)
            .map((answer: any) => String(answer.id)),
    )
    const idCount = quest.sorted_answer_ids.filter(
        (id: unknown) => id != null && !archivedIds.has(String(id)),
    ).length
    return Math.max(idCount, hydratedCount)
}
